import { render, staticRenderFns } from "./pregnant.vue?vue&type=template&id=06d1fa92&scoped=true"
import script from "./pregnant.vue?vue&type=script&lang=js"
export * from "./pregnant.vue?vue&type=script&lang=js"
import style0 from "./pregnant.vue?vue&type=style&index=0&id=06d1fa92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d1fa92",
  null
  
)

export default component.exports